import { ApplicationState, Dispatch } from "application/redux"
import { add, remove } from 'core/spinner/redux/actions'
import { addToaster } from "core/toaster/redux/actions"
import { ToasterType } from "core/toaster/redux/types"
import { fetchData } from "./service"
import { ConfigManagementLogActions, ConfigManagementLogsState, ConfigManagementUploadLogFilter, DEFAULT_LOGS_PAGE_SIZE, RTF_CONFIGURATION_MANAGEMENT_LOGS_DATA_FETCH } from "./types"

function getDataSuccess(payload: ConfigManagementLogsState) {
  return {
    type: ConfigManagementLogActions.setList,
    payload,
  }
}

function clearList() {
  return {
    type: ConfigManagementLogActions.clearList
  }
}

// responses can arrive out of order (initial load, refresh after upload/delete, searches),
// so only the most recent request is allowed to write to the store
let latestRequestId = 0

export function getConfigManagementUploadLogs(filter: ConfigManagementUploadLogFilter = {}, page = 1, pageSize = DEFAULT_LOGS_PAGE_SIZE) {
  return async function (dispatch: Dispatch, getState: () => ApplicationState) {
    const requestId = ++latestRequestId

    try {
      dispatch(add(RTF_CONFIGURATION_MANAGEMENT_LOGS_DATA_FETCH, {}))
      const { data } = await fetchData(filter, page, pageSize)

      if (requestId !== latestRequestId) {
        return
      }

      dispatch(getDataSuccess({
        items: data.items,
        totalElements: parseInt(data.totalElements, 10) || 0,
        filter,
        page,
        pageSize,
      }))
    } catch (error) {
      if (requestId !== latestRequestId) {
        return
      }

      dispatch(addToaster({
        title: 'rtf.configuration_management',
        message: 'error_messages.VIPOC_ERROR_072',
        type: ToasterType.danger,
      }))
      dispatch(clearList())
    } finally {
      dispatch(remove(RTF_CONFIGURATION_MANAGEMENT_LOGS_DATA_FETCH))
    }
  }
}

export function clearConfigManagementUploadLogs() {
  return function (dispatch: Dispatch) {
    return  dispatch(clearList())
  }
}